// extracted by mini-css-extract-plugin
export default {"containerSustainability":"viewSustainability_containerSustainability__Oex1B","itemContainer":"viewSustainability_itemContainer__TSCbZ"};